import(/* webpackMode: "eager", webpackExports: ["BusinessPageView"] */ "/home/runner/work/multi-domain-website-framework/multi-domain-website-framework/apps/nippon-center-pakistan/src/components/audience/BusinessPageView.tsx");
